import request from '@/utils/request'
import { v2Host } from '@/config/host'

export function fetchTemplateSetName(data) {
  return request({
    url: `${v2Host}/dmaker/template/rename`,
    method: 'post',
    data: data,
  })
}

export function fetchTemplatePreview(id) {
  return request({
    url: `${v2Host}/dmaker/template/preview`,
    method: 'get',
    params: {
      id,
    },
  })
}

/**
 * getDmakerTemplateDetail
 * @param {{template_id: number}} params
 */
export function getDmakerTemplateDetail(params) {
  return request({
    url: `${v2Host}/dmaker/template/detail`,
    method: 'get',
    params: params,
  })
}

export function getDmakerProjectHistoryName(params) {
  return request({
    url: `${v2Host}/dmaker/custom/creatives`,
    method: 'get',
    params: params,
  })
}
